import { render, staticRenderFns } from "./VerTodasRecetas.vue?vue&type=template&id=5c8f0db1&scoped=true"
import script from "./VerTodasRecetas.vue?vue&type=script&lang=js"
export * from "./VerTodasRecetas.vue?vue&type=script&lang=js"
import style0 from "./VerTodasRecetas.vue?vue&type=style&index=0&id=5c8f0db1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8f0db1",
  null
  
)

export default component.exports